import React from "react";
import { useNavigate } from "react-router-dom"; 
import "./Services.css";
import { Container } from "react-bootstrap";
import { Service } from "../../../../Components";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Navigation } from "swiper/modules";
import "swiper/css/navigation";
import service1 from "../../../../Assets/Images/services/1.png";


const Services = ({ url, data ,language ,translations}) => {
  const navigate = useNavigate(); 
  const serviceSection = data?.find(item => item.section === "Service Section");
  const services = serviceSection?.data?.services;


  const handleServiceClick = (serviceName) => {
    navigate(`/details/${encodeURIComponent(serviceName)}`);
  };


  return (
    <div className="services-container">
      <Container>
        <div className="services-title">
          {serviceSection?.data?.title}
        </div>
      </Container>
      <div className="services-content">
        {services && services.length > 0 ? (
          <Swiper
            modules={[Navigation]}
            spaceBetween={30}
            slidesPerView={1}
            breakpoints={{
              380: {
                slidesPerView: 1,
              },
              640: {
                slidesPerView: 2,
              },
              768: {
                slidesPerView: 3,
              },
              1024: {
                slidesPerView: 3,
              },
              1280: {
                slidesPerView: 4,
              },
            }}
          >
            {services.map((item, index) => {
              const mainImage =
                item.gallery && item.gallery.length > 0
                  ? `${url}${item.gallery[0].link}`
                  : service1;

              return (
                <SwiperSlide key={index}>
                  <Service
                    onClick={() => handleServiceClick(item.service_name)}
                    title={
                      language === "en"
                        ? item.service_name || ""
                        : item.service_name_ar || ""
                    }
                    image={mainImage}
                    arrow={true}
                  />
                </SwiperSlide>
              );
            })}
          </Swiper>
        ) : (
          <p>No services available</p>
        )}
      </div>
    </div>
  );
};

export default Services;
